import { FileUploadRequest, FileActions } from "@/business/files/domain/files";
import { loadSampleService } from "@/business/files/infrastructure/services/loadSampleService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const loadSample = {
    async execute(file: File): Promise<void> {
        const request: FileUploadRequest =
            FileActions().uploadFileRequest(
                file
            );
        await loadSampleService.execute(await tokenValidation.execute(), request);
    },
};